export default __webpack_public_path__ + "static/media/w_m_2023_a.65e2303f.jpg";